export default __webpack_public_path__ + "assets/images/ac39009591a5ef75f806d4acd9a31394.png";